export const MY_CURRENCY_DISPLAY_PREFIX = "RM";

export const configPrice: { [x: string]: { locales: string; prefix: string } } = {
  IDR: { locales: "id", prefix: "Rp" },
  MYR: { locales: "my", prefix: "RM" },
  SGD: { locales: "en-SG", prefix: "S$" },
  THB: { locales: "th-TH", prefix: "฿" },
  VND: { locales: "vi-VN", prefix: "₫" },
  PHP: { locales: "en-PH", prefix: "₱" },
  BND: { locales: "en-BN", prefix: "B$" },
  KHR: { locales: "km-KH", prefix: "៛" },
  LAK: { locales: "lo-LA", prefix: "₭" },
  MMK: { locales: "my-MM", prefix: "K" },
  USD: { locales: "en-US", prefix: "$" },
  AUD: { locales: "en-AU", prefix: "A$" },
  JPY: { locales: "ja-JP", prefix: "¥" },
  CNY: { locales: "zh-CN", prefix: "¥" },
  HKD: { locales: "en-HK", prefix: "HK$" },
  TWD: { locales: "zh-TW", prefix: "NT$" },
  KRW: { locales: "ko-KR", prefix: "₩" },
  EUR: { locales: "de-DE", prefix: "€" },
  GBP: { locales: "en-GB", prefix: "£" }
};

const COUNTRY_CURRENCY_CODE: { [x: string]: string } = {
  ID: "IDR",
  MY: "MYR",
  SG: "SGD",
  BN: "BND"
};

export const getCurrencyCodeByCountry = (countryCode: string): string =>
  COUNTRY_CURRENCY_CODE[(countryCode || "").toUpperCase()] ?? "IDR";

